var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tile',{staticClass:"h-full",attrs:{"position":_vm.position,"no-fade":""}},[_c('div',{staticClass:"markup"},[_c('h1',[_vm._v("Internet")]),_c('p',{staticClass:"text-xl"},[_vm._v(_vm._s(_vm.isOnline ? 'Online' : 'No connection'))])])])}
var staticRenderFns = []

export { render, staticRenderFns }